import {useEffect, useState} from "react";
import axios from 'axios'
import {setDined} from "../../slices/error/AccessSlice";
import {useDispatch} from "react-redux";
import withAccess from "../hoc/withAccess";

const Start = () => {
    const dispatch = useDispatch();
    const [authlog, setAuthlog] = useState([]);

    useEffect(() => {
        axios.get(`/api/authlog`)
            .then(res => {
                setAuthlog(res.data);
            })
            .catch(e => {
                if (e.status === 403) {
                    dispatch(setDined(true));
                }
            })
    }, []);



    let i = 0;
    let rows = authlog.map((item) =>
        <tr key={i++}>
            <td>{item.login + ' (' + item.nameRus + ')'}</td>
            <td>{item.date}</td>
            <td>{item.startedAt}</td>
            <td>{item.endedAt}</td>
        </tr>
    );

    return (
        <>
            <h1>Учет авторизаций</h1>
            <div className='authlog-table'>
                <table className="table table-striped table-bordered">
                    <thead>
                    <tr>
                        <th scope="col">Менеджер</th>
                        <th scope="col">Дата</th>
                        <th scope="col">Вход</th>
                        <th scope="col">Выход</th>
                    </tr>
                    </thead>
                    <tbody>
                    { rows }
                    </tbody>
                </table>
            </div>
        </>
    )
}

const StartWithAccess = withAccess(Start);
export default StartWithAccess;